import { ModuleInfo } from "fabrix/types";
import translationJson from "./translations.json";
import { icons } from "./icons";
import { RequireAuth } from "../../fabrix/components/authentication/auth-validation";

const moduleRoutes = (): ModuleInfo => {
  let routes = {
    path: "/utilities",
    label: "UTILITIES",
    name: "utilities",
    roles: ["system-admin", "admin", "power-user"],
    id: "073f0bf9-87ed-4d50-abe2-6dec68ff791c",
    lazy: async () => {
      const Page = (await import("./")).default;
      return {
        element: (
          <RequireAuth roles={["admin", "system-admin", "power-user"]}>
            <Page />
          </RequireAuth>
        ),
      };
    },
    translations: translationJson,
    icons: icons,
    children: [
      {
        path: "/utilities/",
        label: "HOME",
        name: "home",
        hide: true,
        id: "d95fda5d-3508-4012-9ac5-9bbd116632a1",
        roles: ["system-admin", "admin", "power-user"],
        lazy: async () => {
          const Page = (await import("./routes/home")).default;
          return {
            element: (
              <RequireAuth roles={["system-admin", "admin", "power-user"]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/utilities/logging",
        label: "LOGGING",
        icon: "utl-logging",
        name: "logging",
        id: "94f1095f-02c1-40ef-8636-e57b144952d9",
        roles: ["system-admin", "admin"],
        lazy: async () => {
          const Page = (await import("./routes/logging")).default;
          return {
            element: (
              <RequireAuth roles={["system-admin", "admin"]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/utilities/notice",
        label: "NOTICE",
        icon: "utl-notice",
        name: "notice",
        id: "03d3a0ac-8729-40bf-9bd7-87cb820d450f",
        roles: ["system-admin"],
        lazy: async () => {
          const Page = (await import("./routes/notices")).default;
          return {
            element: (
              <RequireAuth roles={["system-admin"]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
       {
        path: "/utilities/external-links",
        label: "EXTERNAL_LINKS",
        icon: "utl-external-links",
        name: "external-links",
        id: "a800ecd4-e2ed-4151-ba68-ea63388e8329",
        roles: ["system-admin"],
        lazy: async () => {
          const Page = (await import("./routes/external-links")).default;
          return {
            element: (
              <RequireAuth roles={["system-admin"]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/utilities/defects",
        label: "UTL_DEFECTS",
        icon: "utl-defects",
        name: "defects",
        id: "5a0d6b24-7569-4f6f-9d43-83a89e9a4b2a",
        roles: ["system-admin"],
        lazy: async () => {
          const Page = (await import("./routes/defects")).default;
          return {
            element: (
              <RequireAuth roles={["system-admin"]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/utilities/ai-logging",
        label: "AI_LOGGING",
        icon: "utl-ai-logging",
        name: "ai-logging",
        id: "2b08d579-7256-46a2-b6a8-3faa45f62e10",
        roles: ["system-admin", "admin"],
        lazy: async () => {
          const Page = (await import("./routes/ai-logging")).default;
          return {
            element: (
              <RequireAuth roles={["system-admin", "admin"]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/utilities/token",
        label: "TOKEN",
        icon: "utl-token",
        name: "token",
        id: "5ac4576b-f42c-458a-b2ac-712a62794175",
        roles: ["system-admin", "admin"],
        lazy: async () => {
          const Page = (await import("./routes/token")).default;
          return {
            element: (
              <RequireAuth roles={["system-admin", "admin"]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/utilities/translations",
        label: "TRANSLATIONS",
        icon: "utl-translations",
        name: "translations",
        id: "16b53a18-e934-490c-981e-710b58717245",
        roles: ["system-admin"],
        lazy: async () => {
          const Page = (await import("./routes/translations")).default;
          return {
            element: (
              <RequireAuth roles={["system-admin"]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/utilities/settings",
        label: "SETTINGS",
        name: "settings",
        icon: "utl-settings",
        id: "68701267-9bb2-4152-aa0c-57c50d841349",
        roles: ["system-admin"],
        lazy: async () => {
          const Page = (await import("./routes/settings")).default;
          return {
            element: (
              <RequireAuth roles={["system-admin"]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/utilities/audit",
        label: "AUDIT",
        name: "audit",
        icon: "utl-audit",
        id: "9bac3d8a-b470-4570-9fed-83e14ad09d60",
        roles: ["system-admin", "admin", "power-user"],
        lazy: async () => {
          const Page = (await import("./routes/audit")).default;
          return {
            element: (
              <RequireAuth id="settings" roles={["system-admin", "admin", "power-user"]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/utilities/db-stats",
        label: "UTL_STATISTICS",
        name: "db-stats",
        icon: "utl-stats",
        id: "d1f3e2f3-6f3b-4e2b- ninth-83e14ad09d60",
        roles: ["system-admin", "admin"],
        lazy: async () => {
          const Page = (await import("./routes/stats")).default;
          return {
            element: (
              <RequireAuth id="settings" roles={["system-admin", "admin"]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/utilities/message-templates",
        label: "UTL_MESSAGE_TEMPLATES",
        name: "message-templates",
        icon: "utl-message-templates",
        id: "1dbbf284-10b5-4e7e-8da4-20f825f15a09",
        roles: ["system-admin", "admin"],
        lazy: async () => {
          const Page = (await import("./routes/message-templates")).default;
          return {
            element: (
              <RequireAuth id="settings" roles={["system-admin", "admin"]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },

    ],
  };
  return routes;
};

export default moduleRoutes;
